import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faLightbulb,
} from "@fortawesome/sharp-regular-svg-icons";
import classnames from "classnames";

import styles from "./tip.module.scss";

type LinkObject = {
  href: string;
  display: string;
};

type TipProps = {
  children: string;
  variant?: "tip" | "callout";
  className?: string;
  link?: LinkObject;
  heading?: string;
};

const Tip = ({
  children,
  className,
  variant = "tip",
  link,
  heading,
}: TipProps) => (
  <div
    className={classnames(styles.container, className, {
      [styles.variantTip]: variant === "tip",
      [styles.variantCallout]: variant === "callout",
    })}
  >
    <FontAwesomeIcon
      icon={variant === "tip" ? faLightbulb : faCircleInfo}
      className={styles.icon}
    />
    <div className={styles.contentContainer}>
      <span className={styles.heading}>{heading ?? "Why this matters"}</span>
      <span>{children}</span>
      {link && (
        <a
          className={styles.link}
          target="_blank"
          href={link.href}
          rel="noreferrer"
        >
          {link.display}
        </a>
      )}
    </div>
  </div>
);

export default Tip;
